module.exports = __webpack_public_path__ + "assets/img/step2-2-sz.55d75aab.png";